import { useAtomValue } from "jotai";
import { modal2Atom, modalAtom } from "atoms/modalAtom/modalAtom";
import { LeftNavBar } from "features/LeftNavBar";
import { Outlet } from "react-router-dom";
import { PropsWithChildren, useEffect } from "react";
import axios from "axios";

import { AppModal } from "components/Modal/AppModal";

import useInit from "./hooks/useInit";

const PageLayout = (props: PropsWithChildren): JSX.Element => (
  <div className="flex main-backgound-color main_wrapper">{props.children}</div>
);

export const App = (): JSX.Element => {
  useInit();
  const { isOpen, children } = useAtomValue(modalAtom);
  const { isOpen: isOpen2, children: children2 } = useAtomValue(modal2Atom);

  return (
    <>
      <PageLayout>
        <LeftNavBar />
        <Outlet />
      </PageLayout>
      <AppModal isOpen={isOpen}>{children}</AppModal>
      <AppModal isOpen={isOpen2}>{children2}</AppModal>
    </>
  );
};
